module.exports = __webpack_public_path__ + "static/img/cac-text.fb300eb0.png";